import { createFileRoute } from '@tanstack/react-router'

import { LearnpathsSectionExtendedContent } from '@/learnpaths-assigned-page/components/LearnpathsSectionExtendedContent/LearnpathsSectionExtendedContent'
import useAssignedLearnpath from '@/learnpaths-assigned/hooks/useAssignedLearnpath'

import { retainListFilters } from './company-courses'

export const Route = createFileRoute(
  '/_learning/_company/_list/company-courses/view/$learnpathId',
)({
  search: {
    middlewares: [retainListFilters],
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { learnpathId } = Route.useParams()
  const navigate = Route.useNavigate()
  const learnpath = useAssignedLearnpath({ learnpathId })

  if (!learnpath) {
    return null
  }

  return (
    <LearnpathsSectionExtendedContent
      handleClose={() =>
        navigate({
          to: '/company-courses',
          search: true,
          state: { restoreFilters: true },
        })
      }
      learnpath={learnpath}
    />
  )
}
